import { useTranslation } from 'react-i18next';

const FeaturesCard = () => {
  const { t } = useTranslation();
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 py-0 lg:py-2.5  lg:border-b-2 border-gray-200 px-4 lg:px-0">
        <div className="col-span-1 gap-4 flex items-center shadow-md lg:shadow-none rounded-xl lg:rounded-none">
            <img src="/svg/certify.svg" className="h-14 w-14" alt="offer" />
            <div className="flex flex-col">
                <h2 className="font-bold text-base">{t('home.features.opportunity_discounts.title')}</h2>
                <p className="text-gray-400 text-sm">{t('home.features.opportunity_discounts.description')}</p>
            </div>
        </div>
        <div className="col-span-1 gap-4 flex items-center shadow-md lg:shadow-none rounded-xl lg:rounded-none">
            <img src="/svg/grade.svg" className="h-12 w-12" alt="offer" />
            <div className="flex flex-col">
                <h2 className="font-bold text-base">{t('home.features.promo_codes.title')}</h2>
                <p className="text-gray-400 text-sm">{t('home.features.promo_codes.description')}</p>
            </div>
        </div>
        <div className="col-span-1 gap-4 flex items-center shadow-md lg:shadow-none rounded-xl lg:rounded-none">
            <img src="/svg/delivery.svg" className="h-12 w-12" alt="offer" />
            <div className="flex flex-col">
                <h2 className="font-bold text-base">{t('home.features.free_delivery.title')}</h2>
                <p className="text-gray-400 text-sm">{t('home.features.free_delivery.description')}</p>
            </div>
        </div>
        <div className="col-span-1 gap-4 flex items-center shadow-md lg:shadow-none rounded-xl lg:rounded-none">
            <img src="/svg/pay.svg" className="h-12 w-12" alt="offer" />
            <div className="flex flex-col">
                <h2 className="font-bold text-base">{t('home.features.secure_payment.title')}</h2>
                <p className="text-gray-400 text-sm">{t('home.features.secure_payment.description')}</p>
            </div>
        </div>
    </div>
  );
};

export default FeaturesCard; 